import { initializeApp } from 'firebase/app';
import { getDatabase } from 'firebase/database';

const firebaseConfig = {
    apiKey: "AIzaSyAiTzmq-eHMc6X9LHpE5NeHE3iA7lkZTEU",
    authDomain: "stormwrack-campaign-manager.firebaseapp.com",
    projectId: "stormwrack-campaign-manager",
    storageBucket: "stormwrack-campaign-manager.firebasestorage.app",
    messagingSenderId: "260955354742",
    appId: "1:260955354742:web:30d9f438ca97f270279157"
  };
  

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const database = getDatabase(app);
